import React, { useState } from 'react'
import Navbar from './Navbar/Navbar'
import Intro from './Intro/Intro'
import ExperienceSection from './Experience/ExperienceSection'
import Projects from './Projects/Projects'
import Skills from './Skills/Skill'
import Overlay from './Overlay/Overlay'

import { FloatingButton } from './Navbar/Navbar.styles'
import MailIcon from '@mui/icons-material/Mail';

function Main() {
    const[isToggaled, setIsToggaled] = useState(false)

    const handleToggle = () => {
        setIsToggaled(prev => !prev)
    }

    return (
        <>
            <Navbar toggle={handleToggle} />
            <Intro toggle={handleToggle} />
            <ExperienceSection />
            <Skills />
            <Projects />
            <FloatingButton onClick={handleToggle} >
                <MailIcon sx={{ fontSize: 40, fill: 'white' }} />
            </FloatingButton>
            {
                isToggaled ? (
                    <Overlay toggled={isToggaled} toggle={handleToggle} />
                ) : (
                    <>

                    </>
                )
            }
            
            
        </>
    )
}

export default Main
